import {
  getFactoriesQuery,
  getFarmersGroupQuery,
  getFarmersQuery,
  getForestsGroupQuery,
  getTreesQuery,
} from '@/components/Dashboard/queries';

export const useMapData = () => {
  const { data: farmersGroupData, isLoading: isFarmersGroupsLoading } = getFarmersGroupQuery();
  const { data: forestsGroupData, isLoading: isForestsGroupsLoading } = getForestsGroupQuery();
  const { data: farmersData, isLoading: isFarmersLoading } = getFarmersQuery();
  const { data: treesData, isLoading: isTreesLoading } = getTreesQuery();
  const { data: factoriesData, isLoading: isFactoriesLoading } = getFactoriesQuery();

  // Consider initial data loaded when we have the basic group data
  const isInitialDataLoaded = Boolean(farmersGroupData && forestsGroupData && factoriesData);

  // Full load includes detailed data for individual items
  const isFullyLoaded =
    !isFarmersGroupsLoading &&
    !isForestsGroupsLoading &&
    !isFarmersLoading &&
    !isFactoriesLoading;

  return {
    farmersGroupData,
    forestsGroupData,
    farmersData,
    treesData,
    factoriesData,
    isInitialDataLoaded,
    isFullyLoaded,
    isTreesLoading,
  };
};
